import CompanyDetail, {
    getServerSideProps as gSSP,
} from '@oberoninternal/travelbase-website/dist/components/pages/CompanyDetail';
import { GetServerSideProps } from 'next';
import addGlobalQuery from '../../utils/addGlobalQuery';
import hasRedirect from '../../utils/hasRedirect';

export default CompanyDetail;

export const getServerSideProps: GetServerSideProps = async context => {
    let result = await gSSP(context);

    if ('notFound' in result) {
        const redirect = await hasRedirect(`firma/${context.params?.slug}`, context.locale as string);

        if (redirect) {
            const { redirectDestUrl, redirectHttpCode } = redirect;
            result = {
                redirect: {
                    permanent: redirectHttpCode === 301,
                    destination: redirectDestUrl,
                },
            };
        }
    }

    return addGlobalQuery(result, context.locale);
};
